'use strict';

/**
 * @ngdoc function
 * @name ribytRsvpApp.controller:LegalformsCtrl
 * @description
 * # LegalformsCtrl
 * Controller of the ribytRsvpApp
 */
angular.module( 'ribytRsvpApp' )
    .controller( 'LegalformsCtrl', ['$scope', '$rootScope', 'lodash', 'ENV', '$timeout', '$http', 'notificationService', '$sessionStorage', 'variableSubstitution', '$sce', 'messageDictionary', function ( $scope, $rootScope, _, ENV, $timeout, $http, notificationService, $sessionStorage, $variableSubstitution, $sce, $messageDictionary ) {
        /**
         * Set controller vars
         */

        var invite = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );
        $rootScope.bannerImage = true;
        $rootScope.isTicketPage = false;
        $rootScope.isLandingPage = true;

        _.set( $rootScope, 'rsvpProcess', 'legalForms' );
        /* so, if we have some signed documents already, check that we have signed
        all the required ones from the group. if for example, there is a legal
        that was added after the guest has signed, and somehow they were told to
        go through the sign up process again, they would be presented with the
        ability to sign the legal documents, because there is one that they have
        not signed yet. At this point, they will need to re-sign any other legal
        documents they may have signed already. Direction hasn't been given with
        this situation, but this will allow for an easy way to keep all the signed
        legals in one PDF when the user chooses to download it. Also, for the
        possibility for sending updated legals to be signed in the future.
        */

        // TLDR; we should check if they have signed all the legals for the experience. if it has been modified, we should allow them to resign it

        /*
        Document instructions
        */
        if ( _.get( invite, 'experienceID.guestInformation.documentInstructions' ) ) {
            _.set( $scope, 'documentInstructions', $variableSubstitution.doSubstitutions( _.get( invite, 'experienceID.guestInformation.documentInstructions' ) ) );
        } else {
            _.set( $scope, 'documentInstructions', '<p>You are required to sign off on some legal documents in order to attend the event and complete the RSVP process. Please sign these forms using our secure electronic signature process, powered by HelloSign. You will be asked to agree to this process before you start.</p>' );
        }

        // we give full trust that the code in our database is safe. Otherwise, we get some other issues with styling not being displayed properly
        $scope.trustedHtml = function ( plainText ) {
            return $sce.trustAsHtml( plainText );
        };

        var typeOfInvite = invite.type === 'i' ? 'guest' : 'companion';
        var legalsWeWantSigned = _.filter( _.get( invite, 'experienceID.legals', [] ), function ( legal ) {
            return legal.type[typeOfInvite];
        } );
        // get the last in the array of the hellosign objects. If for some reason they had signed more than one set, the last item will be the most recent one
        var legalsAlreadySigned = _.last( _.get( invite, 'helloSign', [{}] ) );
        var allLegalsSigned = false;

        // if there are legals already signed, make sure they signed all the required ones, according to the experience
        if ( _.get( legalsAlreadySigned, 'event', null ) === 'signature_request_signed' ) {
            _.each( legalsWeWantSigned, function ( legal, index ) {
                if ( _.find( legalsAlreadySigned.legals, function ( signedLegal ) { return signedLegal.id === legal.legalID; } ) ) {
                    legalsWeWantSigned[index].signed = true;
                } else {
                    legalsWeWantSigned[index].signed = false;
                }
            } );

            // check if all the legals in the experience are signed
            if ( _.every( legalsWeWantSigned, { 'signed': true } ) ) {
                allLegalsSigned = true;
            }
        }
        // if they either signed all the required legals, or there are no legals to sign, they don't belong here
        if ( legalsWeWantSigned.length === 0 || allLegalsSigned || !$rootScope.isHasLegals( invite ) ) {
            $rootScope.redirectProperly( invite );
        }
        _.set( $rootScope, 'showTabs', true );
        _.set( $scope, 'status', 'Review & Sign' );
        _.set( $scope, 'isSigning', false );
        var rsvpProcessNext = 'welcome';
        var skipDomainVerification = false;
        var envToAllowLegitDocuments = ['production', 'staging', 'development'];
        if ( !_.includes( envToAllowLegitDocuments, _.get( ENV, 'name', 'dev' ) ) ) {
            skipDomainVerification = true;
        }
        // set the next step here; at this point, it's either welcome screen or companion invitation
        if ( _.get( invite, 'type' ) === 'i' && _.get( invite, 'experienceID.additionalGuests' ) > 0 && _.get( invite, 'companionInfoIDs' ).filter( function ( companion ) {
            return !companion.exludedOnRSVP;
        } ).length < _.get( invite, 'experienceID.additionalGuests' ) ) {
            rsvpProcessNext = 'companionInvitation';
        }

        $scope.openLegals = function () {
            _.set( $scope, 'status', 'Loading documents...' );
            _.set( $scope, 'isSigning', true );

            var data = {
                'templateId': [],
                'legalIDs': [],
                'recipientNameFirst': _.get( invite, 'guest.name.first' ),
                'recipientNameLast': _.get( invite, 'guest.name.last' ),
                'inviteHash': _.get( invite, 'inviteHash' ),
                'rsvpProcessNext': rsvpProcessNext,
                'email': _.get( invite, 'guestID.email.primary' ),
                'guestID': _.get( invite, 'guestID.id' )
            };

            // get only the legalIDs of the legals that are valid for this guest (guest/companion)
            _.each( _.get( invite, 'experienceID.legals' ), function ( experienceLegal ) {
                if ( _.get( invite, 'type' ) === 'i' ) {
                    data.legalIDs.push( _.result( _.find( _.get( invite, 'legals' ), function ( inviteLegal ) {
                        if ( ( _.get( experienceLegal, 'legalID' ) === _.get( inviteLegal, 'id' ) ) && _.get( experienceLegal, 'type.guest' ) ) {
                            return true;
                        }
                    } ), 'id' ) );
                } else if ( _.get( invite, 'type' ) === 'g' ) {
                    data.legalIDs.push( _.result( _.find( _.get( invite, 'legals' ), function ( inviteLegal ) {
                        if ( ( _.get( experienceLegal, 'legalID' ) === _.get( inviteLegal, 'id' ) ) && _.get( experienceLegal, 'type.companion' ) ) {
                            return true;
                        }
                    } ), 'id' ) );
                }
            } );

            // remove any empty objects in the array, and set the data.legalIDs object
            _.set( data, 'legalIDs', _.pull( _.uniq( _.get( data, 'legalIDs' ) ), undefined, '' ) );

            var envToAllowLegitDocuments = ['production', 'staging', 'development'];
            if ( !_.includes( envToAllowLegitDocuments, _.get( ENV, 'name', 'dev' ) ) ) {
                skipDomainVerification = true;
            }

            // make the cal to ribyt api to make the hellosign calls to get the url for the iframe
            $http( {
                'url': _.get( ENV, 'apiEndpoint', 'http://localhost:1338' ) + '/ribyt/rsvp/hellosign',
                'method': 'GET',
                'params': data
            } )
                .then( function success ( response ) {
                    var hellosignResponse = response.data;
                    HelloSign.init( _.get( ENV, 'helloSignKey', '1db5a57e2cb5cdaa25829393884865ce' ) );
                    HelloSign.open( {
                        'url': _.get( hellosignResponse, 'data.url' ),
                        'allowCancel': true,
                        'skipDomainVerification': skipDomainVerification,
                        'uxVersion': 2,
                        'messageListener': function ( eventData ) {
                            // save the info if the legals were signed
                            if ( _.get( eventData, 'event' ) === 'signature_request_signed' ) {
                                var signedData = {
                                    'legalsStatus': _.get( eventData, 'event' ),
                                    'rsvpProcessNext': rsvpProcessNext,
                                    'helloSign': eventData,
                                    'parentID': _.get( invite, 'parentID.id' ),
                                    'guestID': _.get( invite, 'guestID.id' ),
                                    'legalIDs': _.get( data, 'legalIDs' ),
                                    'signature_request_id': _.get( hellosignResponse, 'data.signature_request_id' )
                                };

                                if ( rsvpProcessNext === 'welcome' && _.get( eventData, 'event' ) === 'signature_request_signed' ) {
                                    _.set( signedData, 'rsvp', 'y' );
                                }

                                // save the results from hellosign to the db
                                $http.put( _.get( ENV, 'apiEndpoint', 'http://localhost:1338' ) + '/ribyt/rsvp/hellosign/' + _.get( invite, 'inviteHash' ), signedData )
                                    .then( function success ( response ) {
                                        // TODO: Find out why this stopped working, it was working before
                                        // update the invite a second time from this point with only the rsvpProcess and rsvp value
                                        // this will trigger the confirmation email for the invite in question properly - ns
                                        $http.put( ENV.apiEndpoint + '/ribyt/rsvp/' + _.get( invite, 'inviteHash' ), {
                                            'rsvpProcess': signedData.rsvpProcessNext,
                                            'rsvp': signedData.rsvp
                                        } )
                                        // end TODO:
                                        .then( function success ( ) {
                                           /**
                                             * Response here will be an object with status and an empty data field.
                                             * We used to populat the respones with the invite but it's easier on the
                                             * API side to just make another call since it will use caching and all
                                             * that good stuff.
                                             */
                                            // Always get the invite on load
                                            $http.get( ENV.apiEndpoint + '/ribyt/rsvp/' + _.get( invite, 'inviteHash' ) )
                                            .then( function success ( resp ) {
                                                // Save to sessionStorage
                                                _.set( $sessionStorage, 'invitation', _.get( resp, 'data.data' ) );

                                                var decryptedInvite = $rootScope.decryptInvite( _.get( resp, 'data.data' ) );
                                                _.set( $rootScope, 'rsvp', decryptedInvite.rsvp );
                                                $rootScope.redirectProperly( decryptedInvite );
                                            } );
                                        }, function error ( err ) {
                                            if ( _.get( err, 'data.error_code' ) === 500 ) {
                                                /**
                                                 * Speical notification for 500 which
                                                 */
                                                notificationService.error( _.get( err, 'data.error_description' ), $messageDictionary.error.generalContactSupport );
                                            } else {
                                                notificationService.error( $messageDictionary.error.saveError );
                                                _.set( $scope, 'isSigning', false );
                                                _.set( $scope, 'status', $messageDictionary.buttons.retry );
                                            }
                                        } );
                                    }, function error ( err ) {
                                        $timeout( function () {
                                            notificationService.error( $messageDictionary.error.saveError );
                                            _.set( $scope, 'isSigning', false );
                                            _.set( $scope, 'status', $messageDictionary.buttons.retry );
                                        } );
                                    } );
                            } else {
                                // the document was not signed or completed
                                $timeout( function () {
                                    _.set( $scope, 'isSigning', false );
                                    _.set( $scope, 'status', $messageDictionary.buttons.retry );
                                } );
                            }
                        }
                    } );
                }, function error () {
                    _.set( $scope, 'isSigning', false );
                    _.set( $scope, 'status', $messageDictionary.buttons.retry );
                    notificationService.error( 'There was an error retrieving the legal documents.' );
                } );
        };
    }] );
